module.exports = __webpack_public_path__ + "img/pic_yewu.e689b724.png";